import React from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { supportedLanguages } from "../../../constants";
import { Navigate } from "react-router-dom";
import { changeLanguage } from "../../../redux/slices/messages.slice";
import RouteError from "../../../pages/info/route-error";
import { HomePage } from "../../../pages/home";

export const InitialRoute = {
  path: "/",
  errorElement: <RouteError />,
  Component: () => {
    const dispatch = useAppDispatch();
    const { languageId } = useAppSelector((state) => state.messagesReducer);

    if (languageId >= supportedLanguages.length) {
      return <Navigate to={supportedLanguages[languageId - 1]} />;
    } else {
      dispatch(changeLanguage(1));
      return <Navigate to={supportedLanguages[0]} />;
    }
  },
};
